<template>
    <div class="category-promo my-7">
        <v-layout row wrap class="mb-3" v-if="$vuetify.breakpoint.xsOnly">
            <v-flex xs12 class="text-center">
                <h2 class="mb-2">Devítka na lepší časy</h2>
                <v-btn color="primary" href="https://docs.google.com/forms/d/e/1FAIpQLSedXsfA6_KECOBetvyQAwJiUxzVGCe05BRITqV6NMmDCKw7Dw/viewform" target="_blank" outlined>Chci se zapojit</v-btn>
            </v-flex>
        </v-layout>
      <v-row class="text-sm-left text-center">
        <v-col cols="12" sm="12" md="6">
          <p>Vážený spoluobčane,</p>
          <p>jsme si vědomi těžkostí, které vašim sousedům – živnostníkům způsobuje výpadek příjmů díky
          koronavirové epidemii. Proto jsme kromě jiných opatření připravili i tuto webovou stránku, která
          vám umožní jednoduše si předplatit vaše oblíbené služby. Díky portálu www.prazskyportal.cz si
            můžete snadno a rychle předplatit služby v hodnotě 200,- Kč, 500,- Kč a 1000,- Kč.</p>
          <p>V případě nákupu předplatného živnostník obdrží peníze okamžitě na svůj účet i v případě, kdy
          kvůli coronaviru nemůže své služby aktuálně poskytovat. Zakoupený voucher můžete využít
            kdykoli v průběhu následujících 12 měsíců.</p>
          <p>POMOZTE SVÉMU OBLÍBENÉMU ŽIVNOSTNÍKOVI i VY!</p>
          <p>S Devítkou na lepší časy! </p>
        </v-col>
        <v-col cols="12" sm="12" md="6" class="pt-7">
          <iframe width="100%" height="315" src="https://www.youtube.com/embed/YFyZkSlrZ-E" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </v-col>
      </v-row>
        <v-layout row wrap class="justify-center">
            <v-flex md3 lg4 sm4 xs6 v-for="item in allCategories" :key="item.id" class="lg5-custom pa-2 my-2">
                <router-link :to="'category/' + item.alias">
                    <v-img :src="getProductImage(item.imageUrl)" max-width="200" class="mx-auto">
                        <div class="category-name text-center align-center justify-center">
                            <div>{{item.name}}</div>
                            <p class="caption mb-0" v-if="item.count">{{ item.count}}{{getVoucherLabel(item.count)}}</p>
                        </div>
                    </v-img>
                </router-link>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {getProductImage} from '../../Helper'

    export default {
        name: 'Promo',
        mixins: [getProductImage],
        data () {
            return {

            }
        },
        computed: {
            ...mapGetters([
                'allProducts',
                'allCategories'
            ]),
            imageUrl() {
                return process.env.VUE_APP_ROOT_API;
            }
        },
        methods: {
            ...mapActions([
                'addToCart'
            ]),
            getVoucherLabel(count) {
                if (count > 4) {
                    return ' voucherů';
                }
                if (count > 1) {
                    return ' vouchery'
                }

                return ' voucher';
            }
        }
    }
</script>

<style lang="scss">
    .category-promo {
        .category-name {
            font-size: 21px;
            line-height: 21px;
            height: 42px;
            bottom: 14px;
            width: 100%;
            position: absolute;
            @media #{$tablet-strict} {
                font-size: 22px;
                line-height: 22px;
                height: 50px;
            }
            @media #{$pixel-less-phone} {
                font-size: 17px;
                line-height: 17px;
                bottom: 0;
                height: 50px;
            }
            @media #{$xxs-phone} {
                font-size: 15px;
                line-height: 15px;
                bottom: -4px;
                height: 50px;
            }
        }
        a {
            text-decoration: none;
        }
    }
    @media (min-width: 1264px) and (max-width: 2903px) {
        .flex.lg5-custom {
            width: 20%;
            max-width: 20%;
            flex-basis: 20%;
        }
    }
</style>
